import React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import type { ProductRatingProps } from './ProductRating';
import { ProductRating } from './ProductRating';

export const ProductRatingWithTracking = (props: ProductRatingProps) => {
  const handleReviewsLinkClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    sendGALinkClickEvent(evt, {
      event: 'custom_event',
      event_action: 'Read reviews click',
      event_category: 'Product reviews',
      event_label: 'not set',
    });
  };

  return <ProductRating {...props} onReviewsLinkClick={handleReviewsLinkClick} />;
};
